// extracted by mini-css-extract-plugin
export default {"selectWrapper":"save-modal_selectWrapper__rs7h3","select":"save-modal_select__WXrrm"};